import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { TextField } from '@material-ui/core';
import { DragDropContext, Draggable, Droppable } from '@react-forked/dnd';
import {
    onBeforeDragStartHandler,
    onBlurViewName,
    onChangeViewSelected,
    onDoubleClickView,
    onDragViewEnd,
    onEnterViewName,
} from '../handler/ViewHandler';
import { SettingView } from './SettingView';
import {
    onWheel,
    onTouchEnd,
    onTouchCancel
} from '@/component/ticketKnowledge/handler/ListTicketKnowledgeHandler';
import { useRecoilValue } from 'recoil';
import { corporationAtom } from '@/state/atom/corporationAtom';
import React, { useState } from 'react';

export default function DraggableViewsList(props) {
    const { tabs, viewSelected, setViewSelected, element, nodeListView } = props;
    const currentCorporationDetail = useRecoilValue(corporationAtom);
    const [clickTimeout, setClickTimeout] = useState(null);

    const renderTabName = (view) => {
        let viewNameObj = JSON.parse(view.name);
        let viewName = viewNameObj['jp'].text;

        return (
            <div
                style={{ width: '100%' }}
                onDoubleClick={() =>
                    onDoubleClickView(view, {
                        ...props,
                        clickTimeout,
                        setClickTimeout
                    })
                }
            >
                {!view.isEditName && (
                    <>
                        <div className="info-item-knowledge">
                            <OverFlowTooltipWithTabsMui
                                value={viewName}
                                className={`tabName-tlt ${viewSelected?.id === view.id &&
                                    'title-active'}`}
                                onClick={() =>
                                    onChangeViewSelected(
                                        view,
                                        { ...props, clickTimeout, setClickTimeout },
                                        currentCorporationDetail
                                    )
                                }
                            />

                            <SettingView view={view} {...props} />
                        </div>
                    </>
                )}
                {view.isEditName && (
                    <TextField
                        id={view.id}
                        name={view.id}
                        className="input-view-name"
                        defaultValue={viewName}
                        inputProps={{ maxLength: 20000 }}
                        onKeyPress={e => onEnterViewName(e, view, props)}
                        onBlur={e => onBlurViewName(e, view, props)}
                        inputRef={props.inputViewNameRef}
                        autoFocus
                        variant="filled"
                    />
                )}
            </div>
        );
    };

    const renderTabList = droppableProvided => (
        <>
            {tabs.map((item, index) => (
                <Draggable
                    key={item.id}
                    draggableId={item.id + ''}
                    index={index}
                    isDragDisabled={!item?.isMove}
                >
                    {(provided, snapshot) => (
                        <div
                            className={`item item-knowledge ${viewSelected?.id === item.id &&
                                'active'} ${item.isError ? 'view-error' : ''} ${
                                index === tabs.length - 1 ? 'item-knowledge-last ' : ''
                            }`}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                        >
                            {renderTabName(item)}
                        </div>
                    )}
                </Draggable>
            ))}
            {droppableProvided ? droppableProvided.placeholder : null}
        </>
    );

    const renderTabListWrappedInDroppable = () => (
        <DragDropContext
            onBeforeDragStart={e => onBeforeDragStartHandler(e, props)}
            onDragEnd={e => onDragViewEnd(e, props)}
        >
            <Droppable droppableId="viewDropId" direction="horizontal">
                {droppableProvided => (
                    <div
                        id="container-knowledge"
                        onWheel={event => onWheel(event, element, nodeListView, tabs)}
                        onTouchEnd={event => onTouchEnd(event, element, nodeListView, tabs)}
                        onTouchCancel={event => onTouchCancel(event, element, nodeListView, tabs)}
                        ref={droppableProvided.innerRef}
                        {...droppableProvided.droppableProps}
                    >
                        {renderTabList(droppableProvided)}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );

    return renderTabListWrappedInDroppable()
}
